import DOM from '../Library/DOM';
import Culture from '../culture';

const IS_HU = Culture.getBool();

class Occasion {
    //
    // Create Occasion
    //

    static create(startDate, isStartGuaranteed = false, isDiscounted = false, isFull = false) {
        const o = DOM.createElement('tag occasion', startDate);
        const classList = [];
        const visuallyHiddenText = [];

        if (isFull) {
            classList.push('occasion--full');
            visuallyHiddenText.push(IS_HU ? 'betelt' : 'full');
        } else if (isStartGuaranteed) {
            classList.push('occasion--guaranteed');
            visuallyHiddenText.push(IS_HU ? 'biztosan indul' : 'guaranteed to start');
        }

        if (isDiscounted) {
            visuallyHiddenText.push(IS_HU ? 'kedvezményes időpont' : 'discounted occasion');
            const badge = DOM.createElement('badge', '%', 'span');
            o.append(badge);
        }

        visuallyHiddenText.forEach((text) => {
            o.append(Occasion.createVisuallyHiddenElement(text));
        });

        o.classList.add(...classList);
        if (visuallyHiddenText.length > 0) {
            o.setAttribute('data-bs-toggle', 'tooltip');
            o.setAttribute('data-bs-delay', '{"show":0,"hide":50}');
            o.setAttribute('data-bs-placement', 'top');
            o.setAttribute('data-bs-title', visuallyHiddenText.join(', '));
        }
        return o;
    }

    static createForCalendar(startDay, isStartGuaranteed = false, isDiscounted = false, isFull = false) {
        const createDiv = (classList, visuallyHiddenText, startDate) => {
            const tooltip = visuallyHiddenText.length > 0 ? `data-bs-toggle="tooltip" data-bs-delay='{"show":0,"hide":50}' data-bs-placement="top" data-bs-title="${visuallyHiddenText.join(', ')}"` : '';
            return `<div style="z-index: 2" class="${classList.join(' ')} interactive" ${tooltip}>${startDate}
        ${visuallyHiddenText.map((text) => Occasion.createVisuallyHiddenElementHTML(text)).join('')}</div>`;
        };

        const classList = [];
        const visuallyHiddenText = [];

        if (isDiscounted) {
            classList.push('occasion--discounted');
            visuallyHiddenText.push(IS_HU ? 'kedvezményes időpont' : 'discounted occasion');
        }
        if (isFull) {
            classList.push('occasion--full');
            visuallyHiddenText.push(IS_HU ? 'betelt' : 'full');

            return createDiv(classList, visuallyHiddenText, startDay);
        }
        if (isStartGuaranteed) {
            classList.push('occasion--guaranteed');
            visuallyHiddenText.push(IS_HU ? 'biztosan indul' : 'guaranteed to start');
        }
        return createDiv(classList, visuallyHiddenText, startDay);
    }

    //
    // Create Visually Hidden Element
    //

    static createVisuallyHiddenElement(textContent) {
        const vh = document.createElement('span');
        vh.className = 'visually-hidden';
        vh.textContent = textContent;
        return vh;
    }

    static createVisuallyHiddenElementHTML(textContent) {
        return `<span class="visually-hidden">${textContent}</span>`;
    }
}

export default Occasion;
